<template>
    <section class="w-full flex flex-col items-center pt-10 md:pt-16 lg:pt-20">
        <h4 class="font-bold text-2xl md:text-3xl lg:text-4xl text-center mb-10 md:mb-16 lg:mb-20">
            {{ question }}
        </h4>

        <div class="flex flex-col lg:flex-row w-full">
            <slot></slot>
        </div>

        <transition name="fade">
            <button
                v-show="this.answer"
                class="relative flex overflow-hidden py-4 sm:py-5 px-6 sm:px-10 bg-pink font-bold text-white text-xs leading-none tracking-wider uppercase mt-10 md:mt-16 lg:mt-24 btn btn-primary"
                @click="update()"
            >
                <div class="absolute top-0 left-0 w-full h-full transition-circ btn-primary__swipe">
                    <div class="w-full h-full bg-red -skew-x-16"></div>
                </div>
                <div class="relative mt-1">
                    <div class="transition-circ btn__text01">{{ button }}</div>
                    <div class="absolute top-0 left-0 transition-circ btn__text02">{{ button }}</div>
                </div>
            </button>
        </transition>
    </section>
</template>

<script>
export default {
    props: ['question', 'last'],

    data() {
        return {
            answer: null,
            button: 'Next',
        }
    },

    updated() {
        if (this.last === true) {
            this.button = 'Find Camps'
        }
    },

    methods: {
        update() {
            if (this.answer) {
                /* :: Step 01
                {+} ---------------------------------- */
                if (this.$root.step01.answer === null) {
                    this.$root.step01.question = this.question
                    this.$root.step01.answer = this.answer
                    this.next()

                    /* :: Step 02
                {+} ---------------------------------- */
                } else if (this.$parent.step01.answer && this.$parent.step02.answer === null) {
                    this.$parent.step02.question = this.question
                    this.$parent.step02.answer = this.answer
                    this.next()

                    /* :: Step 03
                {+} ---------------------------------- */
                } else if (this.$parent.step02.answer && this.$parent.step03.answer === null) {
                    this.$parent.step03.question = this.question
                    this.$parent.step03.answer = this.answer
                    this.next()

                    /* :: Step 04
                {+} ---------------------------------- */
                } else if (this.$parent.step03.answer && this.$parent.step04.answer === null) {
                    this.$parent.step04.question = this.question
                    this.$parent.step04.answer = this.answer
                    this.next()
                }
            }
        },

        next() {
            if (this.last === true) {
                this.$parent.getCamps()
                // this.$parent.sendEmail();
            } else {
                this.answer = null
                this.$root.current++
            }
        },
    },
}
</script>
